<fury-loading-indicator [filteredUrlPatterns]="['\\/tasks\\?']"></fury-loading-indicator>
<!-- <mat-progress-spinner mode="indeterminate" color="accent"></mat-progress-spinner> -->
<router-outlet></router-outlet>
